export enum OrderStatus {
  New = "New",
  Drafts = "Drafts",
  Pending = "Pending",
  Inprogress = "Inprogress",
  Denied = "Denied",
  Approved = "Approved",
  Closed = "Closed",
  PartiallyApproved = "Partially Approved",
  Submitted = "Submitted",
  Error = "Error",
  Received = "Received",
  FORM_FILLED = "Form Filled",
  QA_FETCHED = "QA Fetched",
  FORM_ERROR = "Form Error",
  INACCURACY = "Inaccuracy",
  VERIFIED = "Verified",
  NO_STATUS = "No Status",
  SENT_TO_PLAN = "Sent to plan",
  IN_PROGRESS = "In Progress",
  SENDING_TO_PLAN = "Sending to Plan",
  AUTH_NEEDED = "Auth Required",
  AUTH_NOT_REQUIRED = "Auth not required",
  SUCCESS = "success",
  WAITING_FOR_DETERMINATION = "Waiting for determination",
  QA_ERROR = "Qa Error",
  QA_IN_PROGRESS = "QA In Progress",
  NOT_SEND_TO_PLAN = "Not send to plan",
  ARCHIVED = "Archived",
  AUTH_ON_FILE = "Auth on file",
  UNKNOWN = "Unknown",
  UNSPECIFIED = "Unspecified",
  NO_AUTH_REQUIRED = "no_auth_required",
}

export const getKeyFromEnumValuesForOrderStatus = (
  enumValue: string,
): string | undefined => {
  const entries = Object.entries(OrderStatus);
  const foundEntry = entries.find(([_, value]) => value === enumValue);
  return foundEntry ? foundEntry[0] : undefined;
};
